import consumer from "./consumer";
class FileReaderEx extends FileReader {
  constructor() {
    super();
  }

  readAs(blob, ctx) {
    return new Promise((res, rej) => {
      super.addEventListener("load", ({ target }) => res(target.result));
      super.addEventListener("error", ({ target }) => rej(target.error));
      super[ctx](blob);
    });
  }

  readAsArrayBuffer(blob) {
    return this.readAs(blob, "readAsArrayBuffer");
  }

  readAsDataURL(blob) {
    return this.readAs(blob, "readAsDataURL");
  }

  readAsText(blob) {
    return this.readAs(blob, "readAsText");
  }
}

function adjustOwnMessageActions(messageNode, currentUserId) {
  if (!messageNode || !messageNode.classList) return;
  const ownClass = Array.from(messageNode.classList).find((cls) => cls.startsWith("message-from-user-"));
  if (!ownClass) return;
  const authorId = ownClass.replace("message-from-user-", "");
  if (String(authorId) !== String(currentUserId)) return;

  // 自分のメッセージにはお礼(チップ)ボタンは不要なので、icon_btn-container ごと外して
  // リアクション部分だけを chat-message__actions 直下に残す
  // (visibility: hidden 的なやり方だと空の枠が残って不自然な空白になるため要素ごと削除する)
  let reactionContainer;
  const iconBtnContainer = messageNode.querySelector(".icon_btn-container");
  if (iconBtnContainer) {
    reactionContainer = iconBtnContainer.querySelector(".reaction_container");
    if (reactionContainer) {
      iconBtnContainer.replaceWith(reactionContainer);
    } else {
      iconBtnContainer.remove();
    }
  } else {
    reactionContainer = messageNode.querySelector(".reaction_container");
  }

  if (!reactionContainer) return;

  // 既存のリアクションが1件もなければ、サーバー側と同様に枠ごと出さない
  // (中途半端に空の要素を残すとレイアウトが崩れて不自然な空白ができるため要素ごと削除する)
  if (!reactionContainer.querySelector(".scwf-reaction-stamp")) {
    reactionContainer.remove();
    return;
  }

  const addButton = reactionContainer.querySelector(".scwf-reaction-add");
  if (addButton) addButton.remove();

  const picker = reactionContainer.querySelector(".dm-reaction-picker");
  if (picker) picker.remove();

  reactionContainer.querySelectorAll(".scwf-reaction-stamp").forEach((stamp) => {
    stamp.setAttribute("disabled", "disabled");
    stamp.removeAttribute("onclick");
    stamp.removeAttribute("name");
    stamp.removeAttribute("value");
  });
}

window.adjustOwnMessageActions = adjustOwnMessageActions;

window.addEventListener("DOMContentLoaded", () => {
  const sendMessageButton = document.querySelector("#sendMessage");

  if (sendMessageButton) {
    const roomId = sendMessageButton.dataset.roomid;
    const messageInput = document.querySelector("#messageInput");

    const chatChannel = consumer.subscriptions.create(
      { channel: "RoomChannel", room_id: roomId },
      {
        connected() {
          // Called when the subscription is ready for use on the server
        },

        disconnected() {
          // Called when the subscription has been terminated by the server
        },

        received(data) {
          // Called when there's incoming data on the websocket for this channel
          // return alert(data["message"]);
          sendMessageButton.classList.remove("disabled");

          const messageContainer = document.querySelector("#messages");
          if (messageContainer) {
            messageContainer.insertAdjacentHTML(
              "beforeend",
              data["message"]
            );
            adjustOwnMessageActions(messageContainer.lastElementChild, sendMessageButton.dataset.userid);
            scrollToLatestMessage();
            markRoomAsRead(roomId);
            return;
          } else {
            console.error("no message container found.");
          }
        },

        speak: function (message, roomId, imageFileName, imageBlob, contentType, signupGreetingOption) {
          return this.perform("speak", {
            message: message,
            room_id: roomId,
            image_filename: imageFileName,
            image_blob: imageBlob,
            content_type: contentType,
            signup_greeting_option: signupGreetingOption,
          });
        },
      }
    );

    function removeSignupGreetingOptions() {
      document.querySelectorAll("[data-signup-greeting-options]").forEach((element) => {
        element.remove();
      });
    }

    document.querySelectorAll("[data-signup-greeting-option]").forEach((button) => {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        const optionText = button.dataset.signupGreetingOption;
        if (!optionText) return;

        document.querySelectorAll("[data-signup-greeting-option]").forEach((optionButton) => {
          optionButton.disabled = true;
        });
        removeSignupGreetingOptions();
        chatChannel.speak(optionText, roomId, null, null, 0, true);
        messageInput.value = "";
        resetMessageInputSize(messageInput);
        messageInput.blur();
        if (typeof window.removeDraft === "function") {
          window.removeDraft(roomId);
        }
        sendMessageButton.disabled = true;
        sendMessageButton.classList.remove("is-active");
      });
    });

    sendMessageButton.addEventListener("click", async function (event) {
      let imageBlob;
      let imageFileName;
      let contentType = 0;

      if (document.getElementById("fileInput").files.length > 0) {
        console.log("hoge");
        imageBlob = await new FileReaderEx().readAsDataURL(
          document.getElementById("fileInput").files[0]
        );
        imageFileName = document.getElementById("fileInput").files[0].name;
      }

      let reviewRequestBox = document.getElementById("require_to_review");
      if (reviewRequestBox && reviewRequestBox.checked) {
        contentType = 1;
      }

      if (messageInput.value === "" && contentType === 0 && imageFileName == null) return;

      chatChannel.speak(messageInput.value, roomId, imageFileName, imageBlob, contentType, false);
      removeSignupGreetingOptions();
      messageInput.value = "";
      resetMessageInputSize(messageInput);
      messageInput.blur();
      document.getElementById("fileInput").value = "";
      document.getElementById("selectedFileName").textContent = "";
      let selectedFileWrap = document.getElementById("selectedFileWrap");
      if (selectedFileWrap) {
        selectedFileWrap.hidden = true;
      }
      let selectedFileNameRow = document.getElementById("selectedFileNameRow");
      if (selectedFileNameRow) {
        selectedFileNameRow.hidden = true;
      }
      let selectedFilePreview = document.getElementById("selectedFilePreview");
      let selectedFilePreviewImage = document.getElementById("selectedFilePreviewImage");
      if (selectedFilePreviewImage && selectedFilePreviewImage.src) {
        URL.revokeObjectURL(selectedFilePreviewImage.src);
        selectedFilePreviewImage.removeAttribute("src");
      }
      if (selectedFilePreview) {
        selectedFilePreview.hidden = true;
      }
      let review_check_box = document.getElementById('require_to_review')
      if (review_check_box) {
        review_check_box.checked = false;
      }
      let reviewRequestNotice = document.getElementById('reviewRequestNotice');
      if (reviewRequestNotice) {
        reviewRequestNotice.hidden = true;
      }
      sendMessageButton.disabled = true;
      sendMessageButton.classList.remove("is-active");

      return event.preventDefault();
    });
  }
});

function scrollToLatestMessage() {
  window.requestAnimationFrame(() => {
    const scrollArea = document.querySelector(".room-thread__scroll");
    if (scrollArea && scrollArea.scrollHeight > scrollArea.clientHeight) {
      scrollArea.scrollTop = scrollArea.scrollHeight;
      return;
    }
    const element = document.documentElement;
    window.scrollTo(0, element.scrollHeight - element.clientHeight);
  });
}

function resetMessageInputSize(messageInput) {
  if (!messageInput) return;
  const minHeight = Number(messageInput.dataset.minHeight || 48);
  messageInput.style.height = `${minHeight}px`;
  messageInput.style.overflowY = "hidden";
}

function markRoomAsRead(roomId) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  if (!csrfToken || !roomId) return;

  fetch(`/rooms/${roomId}/mark_as_read`, {
    method: "POST",
    headers: {
      "X-CSRF-Token": csrfToken,
      "X-Requested-With": "XMLHttpRequest",
    },
    credentials: "same-origin",
  }).catch(() => {});
}
